import React from "react";
import { Box } from "@mui/material";
import DocumentCell from "./DocumentCell";
import { Typography } from "@mui/material";

const DocumentsListView = ({
  documents,
  removable,
  orgData,
  userData,
  dropped_exists,
  folder,
  onUpdate,
  transferFiles,
  setLoadingTransfer,
  loadingTransfer,
  overrideId,
  navigateWorkspace,
}) => {
  return (
    <div className="flex flex-col w-full max-w-full gap-0  h-fit">
      {documents.length !== 0 ? (
        documents.map((document) => (
          <DocumentCell
            key={document.id}
            document={document}
            removable={removable}
            orgData={orgData}
            userData={userData}
            dropped_exists={dropped_exists}
            folder={folder}
            onUpdate={onUpdate}
            transferFiles={transferFiles}
            setLoadingTransfer={setLoadingTransfer}
            loadingTransfer={loadingTransfer}
            overrideId={overrideId}
            navigateWorkspace={navigateWorkspace}
          />
        ))
      ) : (
        <Box
          sx={{
            padding: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div className="text-h3 text-shadow_50">Aucun document</div>
        </Box>
      )}
    </div>
  );
};

export default DocumentsListView;
